import { Dispatch } from "react";
import cx from "classnames";
import ChevronLeft from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ChevronLeft24PxOutlined";
import ChevronRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ChevronRight24PxOutlined";
import styles from "./Navigation.module.scss";
import { dispatchGalleryMonetateQEvent } from "../Analytics/dispatchGalleryMonetateQEvent";

export interface NavigationProps {
  inModal?: boolean;
  mode?: "image" | "video";
  selectedIndex: number;
  setSelectedIndex: Dispatch<number>;
  numberOfImages: number;
}

export const Navigation = ({
  inModal = false,
  mode,
  numberOfImages,
  selectedIndex,
  setSelectedIndex,
}: NavigationProps) => {
  const disableLeftNavigation = selectedIndex === 0;
  const disableRightNavigation = selectedIndex === numberOfImages - 1;

  const handleNextButtonClick = () => {
    setSelectedIndex(selectedIndex + 1);
    dispatchGalleryMonetateQEvent(
      "RightArrow",
      inModal && mode ? `${mode}Modal` : "generic",
    );
  };

  const handlePreviousButtonClick = () => {
    setSelectedIndex(selectedIndex - 1);
    dispatchGalleryMonetateQEvent(
      "LeftArrow",
      inModal && mode ? `${mode}Modal` : "generic",
    );
  };

  return (
    <>
      <button
        className={cx(styles.navButton, styles.navButtonLeft, {
          [styles.inModal]: inModal,
        })}
        disabled={disableLeftNavigation}
        data-testid="standard:gallery:navigation:left"
        onClick={handlePreviousButtonClick}
        name="previous"
        aria-label="Previous Image"
      >
        <ChevronLeft />
      </button>
      <button
        className={cx(styles.navButton, styles.navButtonRight, {
          [styles.inModal]: inModal,
        })}
        disabled={disableRightNavigation}
        data-testid="standard:gallery:navigation:right"
        onClick={handleNextButtonClick}
        aria-label="Next Image"
        name="next"
      >
        <ChevronRight />
      </button>
    </>
  );
};
